<template>
    <v-card>
        <v-card-title>
            Upload Offline Responses
        </v-card-title>
        <v-divider />
        <v-card-text>
            <div class="text-center mt-4">
                <v-icon
                    v-if="completedSuccessfully"
                    color="#49C84F"
                    size="50px"
                >
                    check_circle
                </v-icon>
                <v-progress-circular
                    v-else
                    :value="progress"
                    :size="60"
                    color="#122448"
                    :rotate="90"
                >
                    <span class="progress-text">
                        {{ progress }}%
                    </span>
                </v-progress-circular>
                <div
                    v-if="completedSuccessfully"
                    class="upload-progress-subtext successfull my-4"
                >
                    Offline Responses Uploaded Successfully!
                </div>
                <div
                    v-else
                    class="upload-progress-subtext my-4"
                >
                    Uploading Responses
                </div>
            </div>
            <v-spacer />
            <div
                class="table-label"
            >
                Respones
            </div>
            <v-data-table
                :headers="offlineResponsesTableHeaders"
                :items="offlineResponses"
                item-key="member"
                hide-default-footer
                class="mt-2 mb-6"
                mobile-breakpoint="0"
            />
        </v-card-text>
        <v-divider />
        <v-card-actions>
            <v-spacer />
            <v-btn
                style="text-transform: none !important"
                class="text-subtitle-2"
                outlined
                :width="this.$vuetify.breakpoint.xs ? '140px' : '76px'"
                @click="cancel"
            >
                Cancel
            </v-btn>
            <v-btn
                style="text-transform: none !important"
                class="text-subtitle-2"
                :disabled="disableImageUpload"
                depressed
                color="primary"
                :width="this.$vuetify.breakpoint.xs ? '162px' : '162px'"
                @click="uploadOfflineImages"
            >
                Upload Offline Images
            </v-btn>
            <v-spacer v-if="this.$vuetify.breakpoint.xs" />
        </v-card-actions>
    </v-card>
</template>
<script>
export default {
    data: () => ({
        offlineResponsesTableHeaders: [
            {
                text: 'Ticket',
                value: 'ticket'
            },
            {
                text: 'Member',
                value: 'member_code'
            },
            {
                text: 'Response',
                value: 'response_code'
            },
            {
                text: 'Status',
                value: 'status'
            },
        ],
        activeDialog: 'responses',
    }),
    computed: {
        showDialog: {
            get() {
                return this.show;                
            },
            set() {
                this.$store.commit('SET_OFFLINE_RESPONSES_STATUSES', []);
                this.close();
            },
        },
        offlineResponses() {
            return this.$store.getters.offlineResponseStatuses;
        },
        disableImageUpload() {
            return !this.enableUplaodImage;
        },
        succeededCount() {
            return this.offlineResponses.filter(response => response.status === 'succeeded').length;
        },
        progressCount() {
            return this.offlineResponses.filter(response => !!response.status).length;
        },
        completedSuccessfully() {
            return this.offlineResponses.length > 0 && this.succeededCount === this.offlineResponses.length;
        },
        progress() {
            return this.offlineResponses.length === 0 ? 0 : Math.floor((this.progressCount/this.offlineResponses.length) * 100);
        },
        enableUplaodImage() {
            return this.$store.getters.offlineImageCount > 0
            && (this.offlineResponses.length === 0 || this.offlineResponses.length === this.progressCount);
        },
    },
    methods: {
        cancel() {
            this.close();
        },
        close() {
            this.$store.commit('SET_SHOW_UPLOAD_OFFLINE_DIALOG', false);
        },
        uploadOfflineImages() {
            this.$emit('upload-offline-images');
        },
    },
};
</script>
